'use client';

import { cn } from '@core/utils';

import { AD_UNIT_IDS } from '@/constants/ad';
import { isBannerAdHidden, useAd } from '@/hooks/useAd';

import { AdBadge } from './AdBadge';

interface DesktopSideAdBannerProps {
  className?: string;
  footer?: React.ReactNode;
}

export const DesktopSideAdBanner = ({
  className,
  footer,
}: DesktopSideAdBannerProps) => {
  const { containerRef, adState } = useAd(AD_UNIT_IDS.DESKTOP_SIDE_BANNER, {
    type: 'banner',
  });

  const hidden = isBannerAdHidden(adState);

  if (hidden && !footer) return null;

  return (
    <aside className={cn('hidden w-250 shrink-0 xl:block', className)}>
      {!hidden && (
        <div className="relative">
          <AdBadge className="right-12 top-12" />
          <div
            ref={containerRef}
            className={cn(
              'overflow-hidden rounded-large bg-Gray-100',
              adState === 'idle' && 'hidden',
              adState === 'loading' && 'animate-pulse',
            )}
            style={{ width: 250, height: 250 }}
          />
        </div>
      )}
      {footer}
    </aside>
  );
};
